// Privacy-first acquisition attribution. Reads non-sensitive referral metadata
// from the URL, keeps FIRST-TOUCH source/campaign in localStorage, and exposes
// whitelisted scalar props for analytics events and the first check-in.
// No sensitive ScoreApp answers are ever accepted or stored.

const ATTR_KEY = "ss_attribution";
const LENS_KEY = "ss_active_lens";

const clip = (v, n = 60) => (v == null ? undefined : String(v).slice(0, n));

export function captureFromUrl() {
  try {
    const p = new URLSearchParams(window.location.search);
    const incoming = {
      source: clip(p.get("source") || p.get("utm_source"), 40),
      campaign: clip(p.get("campaign") || p.get("utm_campaign")),
      content: clip(p.get("content") || p.get("content_story") || p.get("utm_content")),
      lens: clip(p.get("lens"), 40),
      entry_context: clip(p.get("entry_context") || p.get("entry"), 40),
    };
    const hasAny = Object.values(incoming).some(Boolean);
    if (!hasAny) return;
    const existing = getAttribution();
    // First-touch wins for source/campaign/content; lens/entry may refresh.
    const merged = {
      source: existing.source || incoming.source,
      campaign: existing.campaign || incoming.campaign,
      content: existing.content || incoming.content,
      lens: incoming.lens || existing.lens,
      entry_context: incoming.entry_context || existing.entry_context,
    };
    localStorage.setItem(ATTR_KEY, JSON.stringify(clean(merged)));
  } catch (e) { /* never block on attribution */ }
}

function clean(obj) {
  const out = {};
  Object.entries(obj).forEach(([k, v]) => { if (v) out[k] = v; });
  return out;
}

export function getAttribution() {
  try { return JSON.parse(localStorage.getItem(ATTR_KEY)) || {}; }
  catch (e) { return {}; }
}

export function setAttribution(patch) {
  localStorage.setItem(ATTR_KEY, JSON.stringify(clean({ ...getAttribution(), ...patch })));
}

// Props shaped for the analytics event whitelist (keys: source/campaign/content/lens/entry).
export function attributionProps() {
  const a = getAttribution();
  const out = {};
  if (a.source) out.source = a.source;
  if (a.campaign) out.campaign = a.campaign;
  if (a.content) out.content = a.content;
  if (a.lens) out.lens = a.lens;
  if (a.entry_context) out.entry = a.entry_context;
  return out;
}

// Fields shaped for the /checkin body.
export function checkinAttribution() {
  const a = getAttribution();
  return {
    source: a.source || null,
    campaign: a.campaign || null,
    lens: getActiveLens() || a.lens || null,
    entry_context: a.entry_context || null,
  };
}

// Active Signal Lens (context only — never affects scoring).
export const setActiveLens = (id) => localStorage.setItem(LENS_KEY, id);
export const getActiveLens = () => localStorage.getItem(LENS_KEY) || null;
export const clearActiveLens = () => localStorage.removeItem(LENS_KEY);
